import React from 'react'; 
import { Box, Typography, CircularProgress, Tooltip, useMediaQuery } from '@mui/material'; 
import StarsIcon from '@mui/icons-material/Stars'; 
import { useTheme } from '@mui/material/styles';

const Credits = ({ credits, isLoading }) => {
    const theme = useTheme(); 
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Tooltip title="Available credits for fact-checking. 5 credits = 1 fact-check"> 
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      backgroundColor: 'rgba(0, 102, 255, 0.1)',
      padding: '4px 12px',
      borderRadius: '20px',
      cursor: 'pointer',
    }}
  > 
    <StarsIcon sx={{ color: '#0066FF', fontSize: 16 }} />

    {!isMobile && (
      <Typography
        variant="body2"
        sx={{
          color: '#0066FF',
          fontWeight: 550,
          fontSize: {
            xs: '0.80rem',  // 👈 smaller on extra-small screens (mobile)
            sm: '0.90rem', // 👈 normal on small and up
          }
        }}
      >
        Credits:
      </Typography>
    )}

    {isLoading ? (
      <CircularProgress size={14} sx={{ color: '#0066FF' }} />
    ) : (
      <Typography
        variant="body2"
        sx={{
          color: '#0066FF',
          fontWeight: 600,
          fontSize: {
            xs: '0.80rem',  // 👈 smaller on extra-small screens (mobile)
            sm: '0.90rem', // 👈 normal on small and up
          },
        }}
      >
        {console.log(credits)}
        {credits}
      </Typography>
    )}
  </Box>
</Tooltip>


  );
};
export default Credits;